import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { TwitterLogo } from '../../../__legacy__/components/core/icons'
import { useTweetArpMedia } from '../../../__legacy__/components/detail-pages/shared/TweetButton'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { useRemixArpMedia } from '../../arp-utils'
import { Actions } from '../primitives'

export const ArpActionsSection: FC<{ media: IArpMedia }> = observer(({ media }) => {
  const { id, type } = media
  const { status: remixStatus, remix } = useRemixArpMedia(media)
  const { tweet, status: tweetStatus } = useTweetArpMedia(id, type)
  return (
    <Actions.Root>
      <Actions.SecondaryAction
        onClick={tweet}
        loading={tweetStatus !== 'ready'}
        variant="secondary"
        prefixIcon={<TwitterLogo />}
      >
        Tweet
      </Actions.SecondaryAction>
      <Actions.MainAction onClick={remix} loading={remixStatus !== 'ready'} variant="success">
        + Open in Studio
      </Actions.MainAction>
    </Actions.Root>
  )
})
